__webpack_require__.p = "/dev/846-wc-ajout-d-un-flag-editable-comme-attribut/";